import React, { useEffect, useState } from "react";
import LoadingWell from "../../components/Loading/LoadingWell";
import { useLoading } from "../../context/LoadingContext";
import DraggablePreviewPopup from "../../components/DraggablePreviewPopup/DraggablePreviewPopup";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import Navbar from "../../components/Navbar/Navbar";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import "./Article.css"; 


export default function Article() {
  const { loading, setLoading } = useLoading();
  const location = useLocation();
  const previewData = location.state || null;
  const navigate = useNavigate();
  const { user } = useUser();
  const tocRefs = React.useRef({});
  const { slug } = useParams(null);
  const [id, setId] = useState(null);
  const [post, setPost] = useState(previewData ? { title: previewData.title, content: previewData.content, author: previewData.author, image: previewData.thumbnail, short_description: previewData.short_description || previewData.short_description || '', published_at: null } : null);
  // helyi loading state törölve, globális van
  const [error, setError] = useState(null);
  const [latestArticles, setLatestArticles] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [lastUploadStatus, setLastUploadStatus] = useState(null);
  const [lastUploadBody, setLastUploadBody] = useState(null);
  const [activeToc, setActiveToc] = useState(null);
  const [tocOpen, setTocOpen] = useState(window.innerWidth > 1030);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1030);
  const [lastUploadError, setLastUploadError] = useState(null);
  const [navbarVisible, setNavbarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);

  const [labels, setLabels] = useState(() => {
    if (previewData && typeof previewData.tags === 'string') {
      return previewData.tags
        .split(',')
        .map(t => t.trim())
        .filter(Boolean)
        .map(name => ({ name }));
    }
    return [];
  });
  const tocRef = React.useRef(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const storageUrl = process.env.REACT_APP_STORAGE_URL; 

  function handleFacebookShare() {
    const url = window.location.href;
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      '_blank',
      'noopener,noreferrer'
    );
  }

  function handleCopyLink() {
    navigator.clipboard.writeText(window.location.href);
    alert('A cikk linkje vágólapra másolva!');
  }


  function handleEmailShare() {
    window.location.href = `mailto:kutonlineujsag@gmail.com?subject=Cikk%20megosztás%20javaslat&body=Ajánlom%20ezt%20a%20cikket:%20${encodeURIComponent(window.location.href)}`;
  }
  

  // TOC becsukása, ha máshová kattintanak
  useEffect(() => {
    if (!isMobile || !tocOpen) return;
    function handleClickOutside(event) {
      if (tocRef.current && !tocRef.current.contains(event.target)) {
        setTocOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile, tocOpen]);
  const { processedHtml, tocItems } = React.useMemo(() => {
    if (!post || !post.content) return { processedHtml: '', tocItems: [] };
    const backendUrl = process.env.REACT_APP_STORAGE_URL;
    let fixedHtml = post.content.replace(
      /src="\/storage\/images\//g,
      `src="${backendUrl}/storage/images/`
    );
    const parser = new window.DOMParser();
    const doc = parser.parseFromString(fixedHtml, 'text/html');
    // Performance: lazy-load images in content
    try {
      doc.querySelectorAll('img').forEach(img => {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        // Ensure images don't overflow layout
        const style = img.getAttribute('style') || '';
        if (!/max-width\s*:\s*100%/i.test(style)) {
          img.setAttribute('style', `${style ? style + '; ' : ''}max-width: 100%; height: auto;`);
        }
      });
    } catch (e) {
      // ignore
    }
    const selectors = ['h3'];
    const found = [];
    selectors.forEach(sel => {
      doc.querySelectorAll(sel).forEach((el, idx) => {
        const text = el.textContent.trim();
        if (text && !found.some(item => item.text === text)) {
          const id = `${sel}-toc-${idx}-${text.replace(/\s+/g, '-')}`;
          el.setAttribute('id', id);
          found.push({ text, id });
        }
      });
    });
    return { processedHtml: doc.body.innerHTML, tocItems: found };
  }, [post]);
  const tocIds = tocItems.map(item => item.id);

  useEffect(() => {
    document.title =  loading ?"Kútonline - Cikk" : post ? `Kútonline - ${post.title}` : "Kútonline - Cikk";
  }, [loading, post]);
  
  useEffect(() => {
    if (!id) return;
    const token = localStorage.getItem('token');
    const isActivated = !!(user && user.is_activated);
    const url = isActivated
      ? `${apiUrl}/posts/${id}/labels/all`
      : `${apiUrl}/posts/${id}/labels`;

    fetch(url, {
      headers: {
        Accept: 'application/json',
        ...(isActivated && token ? { Authorization: `Bearer ${token}` } : {}),
      },
      credentials: 'include',
    })
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(data => setLabels(Array.isArray(data) ? data : []))
      .catch(() => setLabels([]));
  }, [id, user, apiUrl]);

  // Track if navbar is visible (scrolling up)
  

  useEffect(() => {
    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentY = window.scrollY;
          if (currentY < 10) {
            setNavbarVisible(true);
          } else if (currentY < lastScrollY) {
            setNavbarVisible(true); // scrolling up
          } else {
            setNavbarVisible(false); // scrolling down
          }
          setLastScrollY(currentY);
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lastScrollY]);

  // Listen for resize to update isMobile and tocOpen
  useEffect(() => {
    function handleResize() {
      const mobile = window.innerWidth <= 1030;
      setIsMobile(mobile);
      if (mobile) setTocOpen(false);
      else setTocOpen(true);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Scrollspy: kiemeli az aktuális szakasz linkjét
  useEffect(() => {
    if (!post || !tocIds.length) return;
    const navbarOffset = 300; // px, adjust to your navbar height
    function onScroll() {
      let minDist = Infinity;
      let currentId = null;
      for (let i = 0; i < tocIds.length; i++) {
        const el = document.getElementById(tocIds[i]);
        if (el) {
          const rect = el.getBoundingClientRect();
          const dist = Math.abs(rect.top - navbarOffset);
          if (rect.top - navbarOffset <= 0 && dist < minDist) {
            minDist = dist;
            currentId = tocIds[i];
          }
        }
      }

      setActiveToc(prev => (prev !== currentId ? currentId : prev));
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [post, tocIds]);


  // Scroll TOC so active item is at the top (unless near end)
  useEffect(() => {
    if (!activeToc || !tocRefs.current[activeToc]) return;
    const el = tocRefs.current[activeToc];
    const tocContent = el?.parentElement?.parentElement;
    if (!el || !tocContent) return;
    const offset = 120; // px from top
    const elOffsetTop = el.offsetTop - offset;
    const tocHeight = tocContent.offsetHeight;
    const maxScroll = tocContent.scrollHeight - tocHeight;
    // If already visible in viewport, skip scrolling to avoid jank
    const currentTop = tocContent.scrollTop;
    if (el.offsetTop >= currentTop + 20 && el.offsetTop <= currentTop + tocHeight - 40) {
      return;
    }
    let targetScroll = elOffsetTop;
    if (targetScroll > maxScroll) targetScroll = maxScroll;
    if (targetScroll < 0) targetScroll = 0;
    tocContent.scrollTo({ top: targetScroll, behavior: 'smooth' });
  }, [activeToc]);

  
  useEffect(() => {
  if (previewData) {
    setLoading(false);
    return; // skip fetch when previewing
  }
  if (!slug) return;
  if (post) return;


  const fetchArticle = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    let url = `${apiUrl}/posts/${slug}`; // try public API first

    try {
      let res = await fetch(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          Accept: "application/json",
        },
        credentials: "include",
      });

      // If not found and user is activated, try admin API
      if (res.status === 404 && user?.is_activated) {
        url = `${apiUrl}/admin/article/${slug}`;
        res = await fetch(url, {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            Accept: "application/json",
          },
          credentials: "include",
        });
      }

      if (res.status === 404) {
        setError("404");
        setLoading(false);
        return;
      }

      if (!res.ok) throw new Error("Network response was not ok");

      const data = await res.json();
      setPost({ ...(data || {}), short_description: data.short_description || "" });
      setId(data.id);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchArticle();
}, [slug, user, previewData, apiUrl, setLoading]);

  // If preview contains a File thumbnail, create an object URL for display
  useEffect(() => {
    if (post && post.image && typeof post.image === 'object') {
      try {
        const url = URL.createObjectURL(post.image);
        setPreviewImageUrl(url);
        return () => URL.revokeObjectURL(url);
      } catch (e) {
        setPreviewImageUrl(null);
      }
    } else {
      setPreviewImageUrl(null);
    }
  }, [post]);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    fetch(`${apiUrl}/latest_posts10`)
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(data => {
        // Normalize latest articles so subtitle is always present
        const items = Array.isArray(data) ? data.map(a => ({ ...(a || {}), subtitle: (a && (a.subtitle || a.short_description)) || '' })) : [];
        setLatestArticles(items);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [id, apiUrl,setLoading]);
    
  // Egyetlen loading state: csak akkor lesz false, ha minden adat betöltött
  const [dataReady, setDataReady] = useState(false);

  useEffect(() => {
    setDataReady(false);
  }, [slug, previewData, apiUrl, id]);

  useEffect(() => {
    // Ha minden szükséges adat betöltött, loading false
    if ((post && latestArticles.length > 0) || previewData) {
      setLoading(false);
      setDataReady(true);
    }
  }, [post, latestArticles, setLoading]);

  useEffect(() => {
    if (loading) {
      document.body.classList.add('article-loading-active');
    } else {
      document.body.classList.remove('article-loading-active');
    }
    return () => {
      document.body.classList.remove('article-loading-active');
    };
  }, [loading]);

  return (
    <div>
      <Navbar />
      <DarkModeButton/>
      {(loading || !dataReady) && (
        <div className="article-loading-overlay">
          <LoadingWell />
        </div>
        
      )}
      {(loading || !dataReady) && (
        <div className="article-loading-spacer">

        </div>
        
      )}
      {(!loading && dataReady) && (
      <div className="article-page-container">
        {/* Debug panel for upload result (visible when attempting preview upload) */}
        {(lastUploadStatus || lastUploadBody || lastUploadError) && (
          <div style={{border: '1px solid #f1c0c0', background: '#fff6f6', padding: 12, margin: 12, borderRadius: 6}}>
            <strong>Upload debug:</strong>
            {lastUploadStatus && <div><strong>HTTP:</strong> {lastUploadStatus}</div>}
            {lastUploadError && <div style={{color: 'crimson'}}><strong>Hiba:</strong> {String(lastUploadError)}</div>}
            {lastUploadBody && <pre style={{whiteSpace: 'pre-wrap', maxHeight: 200, overflow: 'auto', marginTop: 8}}>{typeof lastUploadBody === 'string' ? lastUploadBody : JSON.stringify(lastUploadBody, null, 2)}</pre>}
          </div>
        )}
  {post && (
          <div className={`article-row${tocItems.length === 0 ? ' no-toc' : ''}`}>
            {/* Preview popup: shown only when navigated here with previewData */}
            {previewData && (
              <DraggablePreviewPopup>
                <button
                  className="popup-btn upload"
                  onClick={async () => {
                    // Upload the previewed article to backend
                    if (uploadLoading) return;
                    setUploadLoading(true);
                    try {
                      setLastUploadError(null);
                      setLastUploadBody(null);
                      setLastUploadStatus(null);
                      const token = localStorage.getItem('token');
                      const fd = new FormData();
                      fd.append('title', previewData.title || '');
                      fd.append('author', previewData.author || '');
                      fd.append('short_description', previewData.short_description || '');
                      fd.append('content', previewData.content || '');
                      fd.append('type', previewData.type || '');
                      fd.append('tags', previewData.tags || '');
                      // Ensure we always append a thumbnail file — backend requires it
                      async function resolveThumbnail() {
                        const t = previewData.thumbnail;
                        if (!t) return null;

                        // Helper: compress an image File/Blob using canvas to try to get under maxBytes
                        async function compressImage(fileOrBlob, filename, maxBytes = 5000000) {
                          // create image
                          const blob = fileOrBlob instanceof Blob ? fileOrBlob : new Blob([fileOrBlob]);
                          const mime = blob.type || 'image/jpeg';
                          const url = URL.createObjectURL(blob);
                          try {
                            const img = await new Promise((resolve, reject) => {
                              const image = new Image();
                              image.onload = () => resolve(image);
                              image.onerror = (e) => reject(e);
                              image.src = url;
                            });

                            // initial canvas size (limit max dimension)
                            const maxDim = 2000; // reduce very large images
                            let width = img.width;
                            let height = img.height;
                            if (width > maxDim || height > maxDim) {
                              const ratio = Math.min(maxDim / width, maxDim / height);
                              width = Math.round(width * ratio);
                              height = Math.round(height * ratio);
                            }

                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');

                            // Try multiple passes: reduce quality and dimensions until size ok or limits reached
                            let quality = 0.92;
                            let attempt = 0;
                            let resultBlob = null;
                            const minQuality = 0.45;
                            let currentWidth = width;
                            let currentHeight = height;

                            while (attempt < 8) {
                              canvas.width = currentWidth;
                              canvas.height = currentHeight;
                              // draw scaled image
                              ctx.clearRect(0, 0, currentWidth, currentHeight);
                              ctx.drawImage(img, 0, 0, currentWidth, currentHeight);

                              const currentQuality = quality;
                              resultBlob = await new Promise((resolve) => canvas.toBlob(resolve, mime, currentQuality));
                              if (!resultBlob) break;
                              if (resultBlob.size <= maxBytes) break;

                              // reduce quality first
                              if (quality > minQuality) {
                                quality -= 0.12;
                                if (quality < minQuality) quality = minQuality;
                              } else {
                                // then reduce dimensions
                                currentWidth = Math.round(currentWidth * 0.8);
                                currentHeight = Math.round(currentHeight * 0.8);
                              }
                              attempt++;
                            }

                            URL.revokeObjectURL(url);
                            if (!resultBlob) return null;
                            // create File from blob
                            const outFile = new File([resultBlob], filename || 'thumbnail.jpg', { type: resultBlob.type || mime });
                            return outFile;
                          } catch (e) {
                            URL.revokeObjectURL(url);
                            console.error('compressImage failed', e);
                            return null;
                          }
                        }

                        // If already a File instance
                        if (typeof File !== 'undefined' && t instanceof File) {
                          // compress if too large (aim for smaller target to avoid server limits)
                          if (t.size > 5000000) {
                            const compressed = await compressImage(t, t.name, 5000000);
                            return compressed || t;
                          }
                          return t;
                        }

                        // If it's a File-like object (has name/size/type)
                        if (t && typeof t === 'object' && t.name && (t.size || t.type)) {
                          try {
                            // wrap as File if needed
                            const maybeFile = t instanceof File ? t : new File([t], t.name || 'thumbnail.jpg', { type: t.type || 'image/jpeg' });
                            if (maybeFile.size > 5000000) {
                              const compressed = await compressImage(maybeFile, maybeFile.name, 5000000);
                              return compressed || maybeFile;
                            }
                            return maybeFile;
                          } catch (e) {
                            return null;
                          }
                        }

                        // If it's a string (URL or blob URL), try to fetch it and convert to File
                        if (typeof t === 'string') {
                          try {
                            const fetchUrl = t;
                            const resp = await fetch(fetchUrl);
                            if (!resp.ok) return null;
                            const blob = await resp.blob();
                            // Try to derive a filename from URL
                            let filename = 'thumbnail.jpg';
                            try {
                              const urlParts = new URL(fetchUrl);
                              const seg = urlParts.pathname.split('/').pop();
                              if (seg) filename = seg;
                            } catch (e) {
                              // ignore
                            }
                            let file = new File([blob], filename, { type: blob.type || 'image/jpeg' });
                            if (file.size > 5000000) {
                              const compressed = await compressImage(blob, filename, 5000000);
                              file = compressed || file;
                            }
                            return file;
                          } catch (e) {
                            console.error('Thumbnail fetch failed', e);
                            return null;
                          }
                        }
                        return null;
                      }
                      const thumbFile = await resolveThumbnail();
                      // Final safety check: server's PHP limit is often 8MB (8388608). If the file is >=8MB,
                      // abort here and send user back to upload form to select a smaller image.
                      const SERVER_PHP_LIMIT = 8388608; // bytes
                      if (thumbFile && thumbFile.size >= SERVER_PHP_LIMIT) {
                        setLastUploadError('A borítókép túl nagy (több mint a szerver által engedélyezett méret). Kérlek válassz kisebb képet.');
                        alert('A borítókép túl nagy a szerver számára (8MB felett). Kérlek tölts fel kisebb képet.');
                        navigate('/admin/upload', { state: { title: previewData.title, author: previewData.author, content: previewData.content, tags: previewData.tags, thumbnail: previewData.thumbnail, type: previewData.type } });
                        setUploadLoading(false);
                        return;
                      }
                      if (thumbFile) {
                        fd.append('thumbnail', thumbFile);
                      } else {
                        // No thumbnail could be resolved — go back to upload to add one
                        setLastUploadError('A szerver szerint a borítókép (thumbnail) kötelező. Kérlek add meg a borítóképet a feltöltő oldalon.');
                        alert('A cikk feltöltéséhez szükséges a borítókép. Újra megnyitom a feltöltő űrlapot.');
                        navigate('/admin/upload', { state: { title: previewData.title, author: previewData.author, content: previewData.content, tags: previewData.tags, thumbnail: previewData.thumbnail, type: previewData.type } });
                        setUploadLoading(false);
                        return;
                      }
                      const baseApi = apiUrl || 'http://localhost:8000';
                      const url = `${baseApi}/admin/upload`;

                      // Debug: list FormData keys (won't reveal file binary)
                      try {
                        const entries = [];
                        for (const pair of fd.entries()) {
                          entries.push({ key: pair[0], value: pair[1] && pair[1].name ? `(File:${pair[1].name})` : pair[1] });
                        }
                      } catch (e) {
                        console.log('FormData inspection failed', e);
                      }

                      const res = await fetch(url, {
                        method: 'POST',
                        headers: {
                          Authorization: token ? `Bearer ${token}` : undefined,
                          Accept: 'application/json',
                        },
                        body: fd,
                        credentials: 'include',
                      });

                      // Read response body (try JSON, fallback to text)
                      let body = null;
                      try {
                        body = await res.clone().json();
                      } catch (jerr) {
                        try { body = await res.clone().text(); } catch (terr) { body = null; }
                      }

                      setLastUploadStatus(`${res.status} ${res.statusText}`);
                      setLastUploadBody(body);

                      if (!res.ok) {
                        console.error('Upload failed', { status: res.status, statusText: res.statusText, body });
                        const serverMsg = (body && (body.message || body.error || JSON.stringify(body))) || `${res.status} ${res.statusText}`;
                        setLastUploadError(serverMsg);
                        alert(`A feltöltés nem sikerült: ${serverMsg}`);
                      } else {
                        const json = body || {};
                        const id = (json && (json.id || json.data?.id || json.article_id || json.article?.id)) || null;
                        if (id) {
                          navigate(`/article/${id}`);
                        } else {
                          // Successful but no id returned — fallback to admin list
                          navigate('/admin/postcontrol');
                        }
                      }
                    } catch (err) {
                      console.error('Upload exception', err);
                      setLastUploadError(err.message || String(err));
                      alert('Hiba történt a feltöltés közben. Részletek a konzolban.');
                    } finally {
                      setUploadLoading(false);
                    }
                  }}
                >
                  {uploadLoading ? 'Feltöltés...' : 'Feltöltés'}
                </button>
                <button
                  className="popup-btn edit"
                  onClick={() => {
                    // Go back to upload form with the data
                    navigate('/admin/upload', { state: { title: previewData.title, author: previewData.author, content: previewData.content, tags: previewData.tags, thumbnail: previewData.thumbnail, type: previewData.type, short_description: previewData.short_description } });
                  }}
                >
                  Szerkesztés
                </button>
              </DraggablePreviewPopup>
            )}


            {/* Cover rendered in top area (for both preview and live). For 2-column layout
                CSS will move the cover into the main column and keep it sticky under the ads. */}
            {(previewImageUrl || (post && post.image) || (previewData && previewData.thumbnail)) && (
              <div className="preview-cover-above-ads" style={{gridColumn: '1 / span 3'}}>
                <img
                  src={
                    previewImageUrl
                      ? previewImageUrl
                      : (post && post.image)
                        ? (typeof post.image === 'string' ? (post.image.startsWith('http') ? post.image : `${storageUrl}${post.image}`) : '')
                        : (previewData && previewData.thumbnail)
                          ? (typeof previewData.thumbnail === 'string' ? (previewData.thumbnail.startsWith('http') ? previewData.thumbnail : `${storageUrl}${previewData.thumbnail}`) : '')
                          : ''
                  }
                  alt={(post && post.title) || (previewData && previewData.title) || ''}
                  className="preview-cover-image"
                />
              </div>
            )}
            <div
              ref={tocRef}
              className={`toc-column${isMobile && !tocOpen ? ' toc-collapsed' : ''}${navbarVisible ? ' toc-navbar-visible' : ' toc-navbar-hidden'}`}
              style={tocItems.length === 0 ? { display: 'none' } : {}}
            >
              <div className="toc-header">
                <h2
                  className="cim toc-cim"
                  style={{ cursor: isMobile ? 'pointer' : 'default' }}
                  onClick={() => {
                    if (isMobile) {
                      if (tocItems.length === 0) {
                        const mainCol = document.querySelector('.main-column');
                        if (mainCol) {
                          const rect = mainCol.getBoundingClientRect();
                          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                          const offset = window.innerWidth <= 870 ? 80 : 130;
                          window.scrollTo({ top: rect.top + scrollTop - offset, behavior: 'smooth' });
                        }
                      } else {
                        setTocOpen((v) => !v);
                      }
                    }
                  }}
                >
                  Tartalomjegyzék
                  {isMobile && tocItems.length > 0 && (
                    <span style={{ marginLeft: 10, fontSize: '0.9em' }}>{tocOpen ? '▲' : '▼'}</span>
                  )}
                </h2>
              </div>
              <div className="toc-content">
                {(!isMobile || tocOpen) && (
                  <ul>
                    {tocItems.map((item) => {
                      let shown = item.text;
                      let display;
                      const hyphenIdx = shown.indexOf('-');
                      if (hyphenIdx !== -1) {
                        // Only use the part after the first hyphen
                        display = <span style={{ fontWeight: 500 }}>{'- ' + shown.slice(hyphenIdx + 1).trim()}</span>;
                      } else {
                        display = <span style={{ fontWeight: 500 }}>{'- ' + shown}</span>;
                      }
                      return (
                        <li key={item.id} ref={(el) => (tocRefs.current[item.id] = el)}>
                          <a
                            href={`#${item.id}`}
                            className={activeToc === item.id ? 'active-toc-link' : ''}
                            onClick={(e) => {
                              e.preventDefault();
                              const el = document.getElementById(item.id);
                              if (el) {
                                if (isMobile) {
                                  // Mobil nézetben: offsettel görgetés
                                  const rect = el.getBoundingClientRect();
                                  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                                  const offset = 600; // px, navbar vagy egyéb fix elem magassága
                                  window.scrollTo({ top: rect.top + scrollTop - offset, behavior: 'smooth' });
                                  setTocOpen(false);
                                } else {
                                  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }
                              }
                            }}
                          >
                            {display}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            </div>
            <article className={`main-column${tocItems.length === 0 ? ' main-column-merged' : ''}`}>
                <h1 className="cikk-cim">{post.title}</h1>
                {(() => {
                  const subtitle = (post && (post.subtitle || post.short_description)) || (previewData && previewData.short_description) || '';
                  const norm = subtitle ? String(subtitle).trim() : '';
                  if (norm && norm !== String(post.title || '').trim()) {
                    return <h2 className="cikk-alcim">{norm}</h2>;
                  }
                  return null;
                })()}
                <div className="cikk-meta-row">
                  <p className="cikk-meta">
                    Szerző: {post.author || 'Ismeretlen'} • Dátum: {post.published_at ? `${new Date(post.published_at).getFullYear()}.${(new Date(post.published_at).getMonth()+1).toString().padStart(2, '0')}.${new Date(post.published_at).getDate().toString().padStart(2, '0')}.` : 'Unpublished'}
                  </p>
                  <div className="article-share-btn-inline article-share-btn-inline-right">
                    <button className="article-share-btn" onClick={handleFacebookShare} title="Megosztás Facebookon">
                      <i className="fab fa-facebook-f"></i>
                    </button>
                    <button className="article-share-btn" onClick={handleCopyLink} title="Link másolása">
                      <i className="fas fa-link"></i>
                    </button>
                    <button className="article-share-btn" onClick={handleEmailShare} title="Megosztás emailben">
                      <i className="fas fa-envelope"></i>
                    </button>
                  </div>
                </div>
                {/* Cover moved to the top container above ads to keep layout consistent */}
                <section id="bevezeto" className="cikk-torzs">
                  {/* Render post content with added ids for TOC navigation */}
                  <div dangerouslySetInnerHTML={{ __html: processedHtml }} />
                </section>

                  <section id="bekezdesek" className="cikk-torzs">
                      <div className="article-labels">
                        <h3>Címkék:</h3>
                        {labels && labels.length > 0 ? (
                          labels.map(label => {
                            const name = typeof label === 'string' ? label : label?.name;
                            const key = (label && label.id) || name || String(Math.random());
                            return (
                              <span
                                key={key}
                                className="article-label"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  if (name) {
                                    window.location.href = `/search?tag=${encodeURIComponent(name)}`;
                                  }
                                }}
                              >
                                {name ? `#${name}` : '#'}
                              </span>
                            );
                          })
                        ) : (
                          <span className="article-label-empty">Nincsenek címkék</span>
                        )}
                      </div>
                  </section>
                    {/* Megosztás blokk a címkék alatt */}
                    <section className="article-share-block">
                      <h3 className="oszdmeg">Oszd meg a cikket, ha tetszett:</h3>
                      <div className="article-share-btn-group">
                        {/* Facebook megosztás */}
                        <button
                          className="article-share-btn"
                          title="Megosztás Facebookon"
                          onClick={() => {
                            const url = window.location.href;
                            window.open(
                              `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
                              '_blank',
                              'noopener,noreferrer'
                            );
                          }}
                        >
                          <i className="fab fa-facebook-f"></i>
                        </button>
                        {/* Link másolása vágólapra */}
                        <button
                          className="article-share-btn"
                          title="Link másolása"
                          onClick={() => {
                            navigator.clipboard.writeText(window.location.href);
                            alert('A cikk linkje vágólapra másolva!');
                          }}
                        >
                          <i className="fas fa-link" style={{fontSize: '2.2rem', color: '#19764b'}}></i>
                        </button>
                        {/* Email küldése a kutonlineujsagnak */}
                        <a
                          className="article-share-btn"
                          title="Email küldése a Kútonline újságnak"
                          href={`mailto:kutonlineujsag@gmail.com?subject=Cikk%20megosztás%20javaslat&body=Ajánlom%20ezt%20a%20cikket:%20${encodeURIComponent(window.location.href)}`}
                        >
                          <i className="fas fa-envelope" style={{fontSize: '2.2rem', color: '#19776d'}}></i>
                        </a>
                      </div>                      
                    </section>
                    <div style={{textAlign: 'center', marginTop: 24}}>
                        <a
                          href="/support"
                          className="article-support-btn"
                        >
                          Támogasd a munkásságunkat!
                        </a>
                      </div>
              </article>
              <aside className="sidebar-column">
                <section className="latest-articles">
                  <h2 className="cim">Legfrissebb cikkek</h2>
                  {latestArticles && latestArticles.length > 0 ? (
                    <ul className="latest-articles-list">
                      {latestArticles.map(article => (
                        <li key={article.id} className="latest-article-item">
                          <a href={`/article/${article.slug}`} className="latest-article-link">
                            {article.thumbnail && (
                              <img src={`${storageUrl}${article.thumbnail}`} alt={article.title} />
                            )}
                            <span className="latest-article-title">{article.title}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div style={{color: '#888', fontStyle: 'italic', textAlign: 'center'}}>Nincsenek friss cikkek</div>
                  )}
                </section>
              </aside>
            {/* </div> */}
          </div>
        )}
  {error === '404' ? (
          <div style={{color: 'black', textAlign: 'center', margin: 24}}>
            <h2>404 A keresett cikk nem található</h2>
            <a href="/" style={{color: '#1976d2', textDecoration: 'underline'}}>Vissza a főoldalra</a>
          </div>
        ) : error && (
          <div style={{color: 'red', textAlign: 'center', margin: 24}}>A cikk betöltése sikertelen, kérjük próbálja később</div>
        )}
      </div>
      )}
      <ScrollToTopButton />
    </div>
  );
   
  


}